import { c as _c } from "react/compiler-runtime";
import { Global } from 'shared/styled/global';
import { getIn } from 'final-form';
import React from 'react';
import { Field, Form, useForm, useFormState } from 'react-final-form';
import { useSelector } from 'react-redux';
import countries from 'shared/countries';
import Select from 'shared/select';
import { Link } from 'shared/typography';
import { disableAutoCompleteInput } from 'shared/utils/form';
import Button from '../../button';
import Divider from '../../divider';
import FormError from '../../form-error';
import { Box, Flex, Grid } from '../../grid';
import Input from '../../input';
import Label from '../../label';
import Switch from '../../switch';
import Textarea from '../../textarea';
import provinces_ from '../../utils/za-provinces';
import { ClientFieldReference, FieldPrefixContext, LabelField, NameField, PrivateField, RequiredField } from '../shared';
import { FormattedMessage } from 'react-intl';
import { LocationMap } from '../../location-map';
const PIN_PATH = `M20.2,15.7L20.2,15.7c1.1-1.6,1.8-3.6,1.8-5.7c0-5.6-4.5-10-10-10S2,4.5,2,10c0,2,0.6,3.9,1.6,5.4c0,0.1,0.1,0.2,0.2,0.3
  c0,0,0.1,0.1,0.1,0.2c0.2,0.3,0.4,0.6,0.7,0.9c2.6,3.1,7.4,7.6,7.4,7.6s4.8-4.5,7.4-7.5c0.2-0.3,0.5-0.6,0.7-0.9
  C20.1,15.8,20.2,15.8,20.2,15.7z`;
const PinMarker = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    color
  } = t0;
  const size = t1 === undefined ? 20 : t1;
  const t2 = `translate(${-size / 2}px,${-size}px)`;
  let t3;
  if ($[0] !== color || $[1] !== t2) {
    t3 = {
      pointerEvents: "none",
      cursor: "pointer",
      stroke: "#fff",
      strokeWidth: 2,
      fill: color,
      transform: t2
    };
    $[0] = color;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d={PIN_PATH} />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== size || $[5] !== t3) {
    t5 = <svg height={size} viewBox="0 0 24 24" style={t3}>{t4}</svg>;
    $[4] = size;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
const provinces = provinces_.map(p => ({
  label: p,
  value: p
})).sort((a, b) => a.label < b.label ? -1 : 1);
export const Address = t0 => {
  const $ = _c(73);
  const {
    schema,
    disabled,
    menu,
    style,
    className,
    disableAutoComplete,
    isCustom: t1
  } = t0;
  const isCustom = t1 === undefined ? false : t1;
  const prefix = React.useContext(FieldPrefixContext);
  const t2 = isCustom && "custom_fields";
  let t3;
  if ($[0] !== prefix || $[1] !== schema.name || $[2] !== t2) {
    t3 = [prefix, t2, schema.name].filter(_temp);
    $[0] = prefix;
    $[1] = schema.name;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const name = t3.join(".");
  const form = useForm();
  const values = useFormState().values;
  const {
    latitude: defaultLatitude,
    longitude: defaultLongitude
  } = useSelector(_temp2);
  getIn(values, `${name}.gps`) || [];
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Global styles={{
      ".pac-container": {
        zIndex: 60003
      }
    }} />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      flexGrow: 1
    };
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== schema.label) {
    t6 = <Label sx={t5}>{schema.label}</Label>;
    $[6] = schema.label;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== menu || $[9] !== t6) {
    t7 = <Flex justifyContent="space-between">{t6}{menu}</Flex>;
    $[8] = menu;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Divider mt={1} mb={4} gradient={false} />;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  const t9 = `${className}`;
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = ["1fr", "1fr 1fr"];
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== defaultLatitude || $[14] !== defaultLongitude || $[15] !== form || $[16] !== name || $[17] !== schema.show_map) {
    t11 = schema.show_map && <><Field name={`${name}.gps`}>{t12 => {
          const {
            input
          } = t12;
          return <Box gridColumn="1 / -1"><LocationMap defaultCenter={[defaultLatitude, defaultLongitude]} center={input.value} setCenter={input.onChange} onGeoCode={parts => {
              form.batch(() => {
                for (const [k, v_0] of Object.entries(parts)) {
                  form.change(`${name}.${k}`, v_0);
                }
              });
            }} /></Box>;
        }}</Field></>;
    $[13] = defaultLatitude;
    $[14] = defaultLongitude;
    $[15] = form;
    $[16] = name;
    $[17] = schema.show_map;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  const t12 = `${name}.street_address`;
  let t13;
  if ($[19] !== schema.required) {
    t13 = value => {
      if (schema.required && !value) {
        return <FormattedMessage id="DynamicFields.Address.streetAddressRequired" defaultMessage="Enter a street address" />;
      }
    };
    $[19] = schema.required;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== disableAutoComplete || $[22] !== disabled) {
    t14 = t15 => {
      const {
        input: input_0,
        meta: meta_0
      } = t15;
      return <Box gridColumn="1 / -1"><Label mb={2} invalid={meta_0.touched && meta_0.error}><FormattedMessage id="DynamicFields.Address.streetAddress" defaultMessage="Street address" /></Label><Textarea {...disableAutoCompleteInput(input_0, disableAutoComplete)} tabIndex={disabled ? -1 : undefined} invalid={meta_0.touched && meta_0.error} />{meta_0.error && meta_0.touched && <FormError>{meta_0.error}</FormError>}</Box>;
    };
    $[21] = disableAutoComplete;
    $[22] = disabled;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== t12 || $[25] !== t13 || $[26] !== t14) {
    t15 = <Field name={t12} validate={t13}>{t14}</Field>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  const t16 = `${name}.city`;
  let t17;
  if ($[28] !== schema.required) {
    t17 = value_0 => {
      if (schema.required && !value_0) {
        return <FormattedMessage id="DynamicFields.Address.cityRequired" defaultMessage="Enter a city" />;
      }
    };
    $[28] = schema.required;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== disableAutoComplete || $[31] !== disabled) {
    t18 = t19 => {
      const {
        input: input_1,
        meta: meta_1
      } = t19;
      return <Box><Input {...disableAutoCompleteInput(input_1, disableAutoComplete)} label={<FormattedMessage id="DynamicFields.Address.city" defaultMessage="City" />} tabIndex={disabled ? -1 : undefined} type="text" error={meta_1.touched && meta_1.error} /></Box>;
    };
    $[30] = disableAutoComplete;
    $[31] = disabled;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[33] !== t16 || $[34] !== t17 || $[35] !== t18) {
    t19 = <Field name={t16} validate={t17}>{t18}</Field>;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
    $[36] = t19;
  } else {
    t19 = $[36];
  }
  let t20;
  if ($[37] !== disableAutoComplete || $[38] !== disabled || $[39] !== name || $[40] !== schema.required || $[41] !== values) {
    t20 = values[name]?.country === "ZA" ? <Field name={`${name}.province`} validate={value_1 => {
      if (schema.required && !value_1) {
        return <FormattedMessage id="DynamicFields.Address.provinceRequired" defaultMessage="Select a province" />;
      }
    }}>{t21 => {
        const {
          input: input_2,
          meta: meta_2
        } = t21;
        return <Box><Select {...input_2} label={<FormattedMessage id="DynamicFields.Address.province" defaultMessage="Province" />} tabIndex={disabled ? -1 : undefined} invalid={meta_2.touched && meta_2.error}><option />{provinces.map(_temp3)}</Select>{meta_2.error && meta_2.touched && <FormError>{meta_2.error}</FormError>}</Box>;
      }}</Field> : <Field name={`${name}.province`} validate={value_3 => {
      if (schema.required && !value_3) {
        return <FormattedMessage id="DynamicFields.Address.provinceorStateRequired" defaultMessage="Enter a province or state." />;
      }
    }}>{t22 => {
        const {
          input: input_3,
          meta: meta_3
        } = t22;
        return <Box><Input {...disableAutoCompleteInput(input_3, disableAutoComplete)} label={<FormattedMessage id="DynamicFields.Address.provinceOrState" defaultMessage="Province/State" />} tabIndex={disabled ? -1 : undefined} type="text" error={meta_3.touched && meta_3.error} /></Box>;
      }}</Field>;
    $[37] = disableAutoComplete;
    $[38] = disabled;
    $[39] = name;
    $[40] = schema.required;
    $[41] = values;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  const t21 = `${name}.postal_code`;
  let t22;
  if ($[43] !== schema.required) {
    t22 = value_4 => {
      if (schema.required && !value_4) {
        return <FormattedMessage id="DynamicFields.Address.postalCodeRequired" defaultMessage="Enter a postal code." />;
      }
    };
    $[43] = schema.required;
    $[44] = t22;
  } else {
    t22 = $[44];
  }
  let t23;
  if ($[45] !== disableAutoComplete || $[46] !== disabled) {
    t23 = t24 => {
      const {
        input: input_4,
        meta: meta_4
      } = t24;
      return <Box><Input {...disableAutoCompleteInput(input_4, disableAutoComplete)} label={<FormattedMessage id="DynamicFields.Address.postalCode" defaultMessage="Postal code" />} tabIndex={disabled ? -1 : undefined} type="text" error={meta_4.touched && meta_4.error} /></Box>;
    };
    $[45] = disableAutoComplete;
    $[46] = disabled;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== t21 || $[49] !== t22 || $[50] !== t23) {
    t24 = <Field name={t21} validate={t22}>{t23}</Field>;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  const t25 = `${name}.country`;
  let t26;
  if ($[52] !== schema.required) {
    t26 = value_5 => {
      if (schema.required && !value_5) {
        return <FormattedMessage id="DynamicFields.Address.countryRequired" defaultMessage="Select a country." />;
      }
    };
    $[52] = schema.required;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== disabled) {
    t27 = t28 => {
      const {
        input: input_5,
        meta: meta_5
      } = t28;
      return <Box><Select {...input_5} label={<FormattedMessage id="DynamicFields.Address.country" defaultMessage="Country" />} tabIndex={disabled ? -1 : undefined} invalid={meta_5.touched && meta_5.error}><option />{countries.map(_temp4)}</Select>{meta_5.error && meta_5.touched && <FormError>{meta_5.error}</FormError>}</Box>;
    };
    $[54] = disabled;
    $[55] = t27;
  } else {
    t27 = $[55];
  }
  let t28;
  if ($[56] !== t25 || $[57] !== t26 || $[58] !== t27) {
    t28 = <Field name={t25} validate={t26}>{t27}</Field>;
    $[56] = t25;
    $[57] = t26;
    $[58] = t27;
    $[59] = t28;
  } else {
    t28 = $[59];
  }
  let t29;
  if ($[60] !== style || $[61] !== t11 || $[62] !== t15 || $[63] !== t19 || $[64] !== t20 || $[65] !== t24 || $[66] !== t28 || $[67] !== t9) {
    t29 = <Grid style={style} className={t9} gridTemplateColumns={t10}>{t11}{t15}{t19}{t20}{t24}{t28}</Grid>;
    $[60] = style;
    $[61] = t11;
    $[62] = t15;
    $[63] = t19;
    $[64] = t20;
    $[65] = t24;
    $[66] = t28;
    $[67] = t9;
    $[68] = t29;
  } else {
    t29 = $[68];
  }
  let t30;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <Divider my={4} gradient={false} />;
    $[69] = t30;
  } else {
    t30 = $[69];
  }
  let t31;
  if ($[70] !== t29 || $[71] !== t7) {
    t31 = <Box>{t4}{t7}{t8}{t29}{t30}</Box>;
    $[70] = t29;
    $[71] = t7;
    $[72] = t31;
  } else {
    t31 = $[72];
  }
  return t31;
};
export default Address;
export const toString = value => {
  return value ? ['street_address', 'city', 'province', 'country', 'postal_code'].map(v => value[v]).filter(v => v).map((v, idx) => v).join(', ') : '';
};
export const View = t0 => {
  const $ = _c(10);
  const {
    value,
    schema
  } = t0;
  let t1;
  if ($[0] !== schema.show_map || $[1] !== value) {
    t1 = schema.show_map && value?.gps && <Box><Link rel="noopener noreferrer" target="_blank" href={`https://maps.google.com/maps?&z=16&q=${value.gps[0]}+${value.gps[1]}&ll=${value.gps[0]}+${value.gps[1]}`} sx={{
        width: "100%",
        display: "inline-block"
      }}><Box as="img" alt="map" borderRadius={2} src={`https://maps.google.com/maps/api/staticmap?key=${__GOOGLE_MAPS_KEY__}&center=${value.gps[0]},${value.gps[1]}&zoom=14&size=200x200&sensor=false&markers=color:red|${value.gps[0]},${value.gps[1]}`} /></Link></Box>;
    $[0] = schema.show_map;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== value) {
    t2 = value && ["street_address", "city", "province", "country", "postal_code"].map(v => value[v]).filter(_temp5).map(_temp6);
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2) {
    t3 = <Box>{t2}</Box>;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t1 || $[8] !== t3) {
    t4 = <Box>{t1}{t3}</Box>;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export const Edit = t0 => {
  const $ = _c(13);
  const {
    isEditing,
    className,
    isUniqueFieldName,
    hideRequired,
    showClientFieldReference,
    value,
    menu,
    style,
    disableAutoComplete
  } = t0;
  const [showMore, setShowMore] = React.useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setShowMore(_temp7);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const toggleMore = t1;
  const removable = value.removable;
  let t2;
  if ($[1] !== className || $[2] !== disableAutoComplete || $[3] !== hideRequired || $[4] !== isEditing || $[5] !== isUniqueFieldName || $[6] !== menu || $[7] !== removable || $[8] !== showClientFieldReference || $[9] !== showMore || $[10] !== style || $[11] !== value) {
    t2 = <>{!isEditing ? <Form onSubmit={_temp8}>{() => <Address schema={value} disabled={true} menu={menu} style={style} className={className} disableAutoComplete={disableAutoComplete} />}</Form> : <Grid sx={{
        display: !isEditing ? "none" : null
      }}><LabelField prefix="" /><Field name={"" ? ".show_map" : "show_map"}>{_temp9}</Field>{!hideRequired && <RequiredField prefix="" />}{showMore && <>{showClientFieldReference && removable && <PrivateField prefix="" />}<NameField prefix="" isUniqueFieldName={isUniqueFieldName} removable={removable} />{showClientFieldReference && removable && <ClientFieldReference prefix="" schema={value} />}</>}<Button type="button" onClick={toggleMore} width="100%" variant="outlined" size="small">{showMore ? "Show less ..." : "Show more ..."}</Button></Grid>}</>;
    $[1] = className;
    $[2] = disableAutoComplete;
    $[3] = hideRequired;
    $[4] = isEditing;
    $[5] = isUniqueFieldName;
    $[6] = menu;
    $[7] = removable;
    $[8] = showClientFieldReference;
    $[9] = showMore;
    $[10] = style;
    $[11] = value;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};
function _temp(v) {
  return v;
}
function _temp2(state) {
  return state.geoip;
}
function _temp3(t0) {
  const {
    value: value_2,
    label
  } = t0;
  return <option key={value_2} value={value_2} data-sentry-component="_temp3" data-sentry-source-file="index.tsx">{label}</option>;
}
function _temp4(t0) {
  const {
    value: value_6,
    label: label_0
  } = t0;
  return <option key={value_6} value={value_6} data-sentry-component="_temp4" data-sentry-source-file="index.tsx">{label_0}</option>;
}
function _temp5(v_0) {
  return v_0;
}
function _temp6(v_1, idx) {
  return <Box key={idx} data-sentry-element="Box" data-sentry-component="_temp6" data-sentry-source-file="index.tsx">{v_1}</Box>;
}
function _temp7(v) {
  return !v;
}
function _temp8(value_0) {
  return null;
}
function _temp9(t0) {
  const {
    input
  } = t0;
  return <Flex alignItems="center" data-sentry-element="Flex" data-sentry-component="_temp9" data-sentry-source-file="index.tsx"><Switch size="small" {...input} data-sentry-element="Switch" data-sentry-source-file="index.tsx" data-sentry-element="Switch" /><Box ml={2} data-sentry-element="Box" data-sentry-source-file="index.tsx" data-sentry-element="Box">Show map</Box></Flex>;
}